import Invoices from '@/components/routes/invoices/Invoices'

const invoicesRoutes = [
  {
    name: 'invoices',
    path: '/invoices',
    component: Invoices
  }
]

export default invoicesRoutes
